import { render } from "./DeployVnfAppliance.vue?vue&type=template&id=1235f51a&scoped=true"
import script from "./DeployVnfAppliance.vue?vue&type=script&lang=js"
export * from "./DeployVnfAppliance.vue?vue&type=script&lang=js"

import "./DeployVnfAppliance.vue?vue&type=style&index=0&id=1235f51a&lang=less&scoped=true"
import "./DeployVnfAppliance.vue?vue&type=style&index=1&id=1235f51a&lang=less"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1235f51a"]])

export default __exports__